const MOTIVOS_CURTOS: readonly [RegExp, (tipoObraCodigo: string) => string][] = [
  [/^Cadastre o Tipo de Obra na Obra de destino/, (codigo) => `Sem o Tipo de Obra ${codigo}`],
  [/^Fase acima do FEL-2\.?$/, () => "Fase acima do FEL-2"],
  [/concluída/i, () => "Concluída"],
  [/em fechamento/i, () => "Em fechamento"],
  [/cancelada/i, () => "Cancelada"],
  [/suspensa/i, () => "Suspensa"],
];

export function situacaoCurta(motivo: string, tipoObraCodigo: string): string {
  const curto = MOTIVOS_CURTOS.find(([padrao]) => padrao.test(motivo));
  return curto ? curto[1](tipoObraCodigo) : motivo;
}
